/* pf-quickadd.js — Quick-add global (5 ago 2026, v3)
   Uma variante  -> adiciona já via /cart/add.js (o cart-drawer abre sozinho)
   Várias        -> painel ancorado ao botão, a abrir PARA CIMA (desktop) / bottom sheet (mobile)

   v3 corrige o "entra e sai": abrir o painel dispara eventos de scroll
   (mudança de layout, overflow do body). Só fechamos se o utilizador
   scrollar mesmo — e nunca nos primeiros 350ms. */
(function () {
  if (window.pfQuickAdd) return;
  window.pfQuickAdd = true;

  var MOBILE = 749;
  var lastBtn = null;
  var openedAt = 0;
  var startY = 0;

  function isMobile() { return window.innerWidth > 0 && window.innerWidth <= MOBILE; }

  function add(id, btn) {
    if (btn) btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(id, 10), quantity: 1 })
    }).finally(function () { if (btn) btn.disabled = false; });
  }

  function sheet() { return document.querySelector('[data-pfqs]'); }

  function close() {
    var s = sheet();
    if (!s || s.getAttribute('data-open') !== 'true') return;
    s.setAttribute('hidden', '');
    s.setAttribute('data-open', 'false');
    s.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    lastBtn = null;
  }

  /* Abre SEMPRE para cima do botão. Só cai para baixo se não houver mesmo espaço. */
  function place(panel, btn) {
    if (isMobile()) { panel.style.top = ''; panel.style.left = ''; return; }
    var r = btn.getBoundingClientRect();
    var pw = panel.offsetWidth || 240;
    var ph = panel.offsetHeight || 160;
    var pad = 8;

    var left = r.right - pw;
    if (left < pad) left = pad;
    if (left + pw > window.innerWidth - pad) left = window.innerWidth - pad - pw;

    var top = r.top - pad - ph;              // preferência: PARA CIMA
    if (top < pad) {                          // sem espaço em cima -> por baixo
      top = r.bottom + pad;
      if (top + ph > window.innerHeight - pad) top = Math.max(pad, window.innerHeight - pad - ph);
    }
    panel.style.left = Math.round(left) + 'px';
    panel.style.top = Math.round(top) + 'px';
  }

  function open(btn) {
    var s = sheet();
    if (!s) { window.location.href = btn.getAttribute('data-url') || '/'; return; }
    var list = s.querySelector('[data-pfqs-list]');
    list.innerHTML = '';
    (btn.getAttribute('data-variants') || '').split('~').forEach(function (chunk) {
      var p = chunk.split('|');
      if (p.length < 2) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'pfqs__opt';
      b.setAttribute('data-pfqs-add', p[0]);
      b.innerHTML = '<span></span><span></span>';
      b.children[0].textContent = p[1];
      b.children[1].textContent = p[2] || '';
      list.appendChild(b);
    });
    s.querySelector('[data-pfqs-title]').textContent = btn.getAttribute('data-title') || '';
    s.removeAttribute('hidden');
    s.setAttribute('data-open', 'true');
    s.setAttribute('aria-hidden', 'false');
    lastBtn = btn;
    openedAt = Date.now();
    startY = window.pageYOffset || 0;
    var panel = s.querySelector('.pfqs__panel');
    place(panel, btn);
    requestAnimationFrame(function () { place(panel, btn); });  // reposiciona já com a altura real
    if (isMobile()) document.body.style.overflow = 'hidden';
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    if (t.closest('[data-pfqs-close]')) { close(); return; }
    var opt = t.closest('[data-pfqs-add]');
    if (opt) { e.preventDefault(); add(opt.getAttribute('data-pfqs-add'), null); close(); return; }
    if (t.closest('.pfqs__panel')) return;                 // cliques dentro do painel não fecham
    var btn = t.closest('[data-pfq-add]');
    if (!btn) { close(); return; }                          // clicar fora fecha
    e.preventDefault();
    e.stopPropagation();
    var single = btn.getAttribute('data-single');
    if (single) { add(single, btn); return; }
    if (lastBtn === btn) { close(); return; }               // segundo clique no mesmo botão fecha
    open(btn);
  }, true);

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  window.addEventListener('resize', function () { close(); });
  window.addEventListener('scroll', function () {
    if (!lastBtn || isMobile()) return;
    if (Date.now() - openedAt < 350) return;                // ignora o scroll da própria abertura
    if (Math.abs((window.pageYOffset || 0) - startY) < 10) return;
    close();
  }, { passive: true });
})();
